import { render, staticRenderFns } from "./GuestInfoBottomPrice.vue?vue&type=template&id=4b075214&scoped=true"
import script from "./GuestInfoBottomPrice.vue?vue&type=script&lang=js"
export * from "./GuestInfoBottomPrice.vue?vue&type=script&lang=js"
import style0 from "./GuestInfoBottomPrice.vue?vue&type=style&index=0&id=4b075214&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b075214",
  null
  
)

export default component.exports